import React from 'react';
import Icon, { IconProps } from './Icon';

// clock-rewind *
const HistoryOutlinedSvg: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M22.7 13.5L20.7005 11.5L18.7 13.5M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C15.3019 3 18.1885 4.77814 19.7545 7.42909M12 7V12L15 14"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
const HistoryOutlined: React.FC<Omit<IconProps, 'component'>> = (props) => (
    <Icon
        component={HistoryOutlinedSvg}
        className="s9sicon-history"
        {...props}
    />
);
export default HistoryOutlined;
